import { Controller } from '@hotwired/stimulus'

// Reloads the page with the changed select's value in the query string, so
// the server can re-render the parts of a form that depend on that choice.
export default class extends Controller {
  static values = { url: String }

  reload(event) {
    const { name, value } = event.target
    const url = new URL(this.urlValue || window.location.href, window.location.href)
    url.searchParams.set(name, value)
    if (window.Turbo) {
      window.Turbo.visit(url.toString())
    } else {
      window.location.assign(url.toString())
    }
  }
}
